import { useState } from "react";
import { Link } from "react-router-dom";
import { useAdminStatements } from "../../hooks/use-admin.js";
import { PageSkeleton } from "../../components/skeleton.js";

const LIMIT = 30;

export function AdminStatementsPage() {
  const [page, setPage] = useState(1);
  const { data, isLoading } = useAdminStatements({ page, limit: LIMIT });

  if (isLoading) return <PageSkeleton />;

  return (
    <div className="product-page">
      <h1 className="page-title">Accessibility Statements</h1>
      {data && (
        <>
          <table className="admin-table text-sm">
            <thead>
              <tr>
                <th>Website</th>
                <th className="text-right">Score</th>
                <th className="text-right">Versions</th>
                <th>Confidence</th>
                <th>Latest</th>
              </tr>
            </thead>
            <tbody>
              {data.statements.map((stmt) => (
                <tr key={stmt.id}>
                  <td>
                    <Link to={`/admin/websites/${stmt.websiteId}`}>
                      {stmt.websiteUrl}
                    </Link>
                  </td>
                  <td className="text-right">
                    {stmt.scoreValue != null ? stmt.scoreValue : <span className="text-muted">&mdash;</span>}
                  </td>
                  <td className="text-right">{stmt.versionCount}</td>
                  <td>{stmt.confidence || <span className="text-muted">&mdash;</span>}</td>
                  <td>{stmt.latestGeneratedAt.split("T")[0]}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {data.statements.length === 0 && (
            <p className="text-muted text-center py-2">
              No statements found.
            </p>
          )}
          <div className="d-flex items-center gap-2 mt-3">
            <button
              className="btn btn--secondary btn--sm"
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              Previous
            </button>
            <span className="text-sm">
              Page {page} &middot; {data.total} total
            </span>
            <button
              className="btn btn--secondary btn--sm"
              onClick={() => setPage((p) => p + 1)}
              disabled={data.statements.length < LIMIT}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
}
